(function () {

    angular
        .module('smartertoolsApp')
        .controller('ticketModalsController',
            [
                '$scope', '$location', '$q', '$timeout', 'hostingService', 'licenseKeyService', 'ticketService', 'userPartnerService', 'notificationFactory', 'authenticationService', 'Upload', '$rootScope', 'supportService',
                ticketModalsController
            ]);

    function ticketModalsController($scope, $location, $q, $timeout, hostingService, licenseService, ticketService, partnerService, notify, authenticationService, upload, $rootScope, supportService) {
        const vm = this;
        vm.hasMail = false;
        vm.hasTrack = false;
        vm.hasStats = false;
        vm.hasHosted = false;
        vm.Licenses = {};
        vm.Trials = {};
        vm.ProductLicenses = [];
        vm.startRsaa = false;
        vm.sendingButtonMode = 'send';
        vm.acceptedFileTypes =
            'text/html,' +
            'image/jpg,' +
            'image/jpeg,' +
            'videos/*,' +
            'application/pdf,' +
            'application/x-7z-compressed,' +
            'chemical/x-cmdf,' +
            'application/pkcs7-signature,' +
            'application/xcap-diff+xml,' +
            'text/csv,' +
            'application/vnd.oasis.opendocument.database,' +
            'application/x-msaccess,' +
            'image/png,' +
            'application/atom+xml,' +
            'application/x-rar-compressed,' +
            'text/x-vcard,' +
            'text/calendar,' +
            'application/zip,' +
            'application/vnd.ctc-posml,' +
            'application/vnd.ms-excel.sheet.macroenabled.12,' +
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
            'application/vnd.ms-excel,' +
            'application/vnd.groove-tool-template,' +
            'image/tiff,' +
            'application/rtf,' +
            'video/mp4,' +
            'application/mp4,' +
            'application/json,' +
            'image/gif,' +
            'message/rfc822.application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
            'application/msword';
        vm.acceptedFileExtensions =
            '.7z,.mdf,.b19,.bak,.smime,.p7s,.p7s,.citavitx,.config,.csv,.db,.doc,.docx,.dtt,.eml,.eps,.evtx,.pfx,.gif,.grp,.html,.jpeg,.hdr,.jpg,.json,.log,.mov,.mp3,.mp4,.msg,.mssql,.pdf,.png,.rtf,.rtfd,.sqlite,.srf,.tiff,.tpl,.txt,.xls,.xlsx,.xlsm,.xml,.pml,.zip,.rar,.vcf,.ics';

        // Functions
        vm.checkPartnerships = checkPartnerships;
        vm.getEmailAddresses = getEmailAddresses;
        vm.getLicenses = getLicenses;
        vm.goToModifyLicense = goToModifyLicense;
        vm.hasActiveTrial = hasActiveTrial;
        vm.hasLicenses = hasLicenses;
        vm.hideMessage = hideMessage;
        vm.invalidParser = invalidParser;
        vm.loadLicenses = loadLicenses;
        vm.needsLicense = needsLicense;
        vm.refreshViewedTicket = refreshViewedTicket;
        vm.removeFile = removeFile;
        vm.removeInvalidFiles = removeInvalidFiles;
        vm.showMessage = showMessage;
        vm.startTicket = startTicket;
        vm.submitReply = doSubmitReply;
        vm.submitTicket = doSubmitTicket;
        vm.viewTicket = viewTicket;
        activate();

        // ------------------------------------------------------------------

        function activate() {
            vm.checkPartnerships();
            vm.getLicenses();
            vm.getEmailAddresses();
        }

        function cancelTicketReply() {
            vm.messages.page = 'view';
            vm.messages.cancelMessage = null;
            vm.messages.New = null;
        }

        function checkPartnerships() {
            partnerService.getPartnershipDetails()
                .then((data) => {
                    vm.IsActivePartner = data && data.IsActivePartner;
                });
        }

        function invalidParser(invalidFiles) {
            const pattern = /\.[0-9a-z]{1,5}$/i;
            var parsedString = '';
            for (let i = 0; i < invalidFiles.length; i++) {
                parsedString += invalidFiles[i].name.match(pattern);
                if (i < invalidFiles.length - 1)
                    parsedString += ', ';
            }
            return invalidFiles.length > 1 ? parsedString + ' are' : parsedString + ' is';
        }

        function removeInvalidFiles() {
            if ($scope.invalidFiles != undefined) {
                const count = $scope.invalidFiles.length;
                $scope.invalidFiles.splice(0, count);
            }
        }

        function removeFile(index) {
            $scope.files.splice(index, 1);
        }

        function doSubmitReply() {
            if (vm.ticketReplyForm.$invalid)
                return;

            if (!vm.messages)
                return;

            vm.sendingButtonMode = 'sending';
            $scope.$applyAsync();

            const detail = {
                TicketNumber: vm.messages.Ticket.TicketNumber,
                Subject: vm.messages.New.Subject,
                FromAddress: vm.messages.New.fromEmail,
                CCAddress: vm.messages.New.ccEmail,
                Body: vm.messages.New.Body
            };
            ticketService.getAllowedAttachmentSize()
            .then((response) => {
                if (!response.Success) {
                    notify.error('There was a problem submitting the ticket reply.');
                    vm.sendingButtonMode = 'send';
                    $scope.$applyAsync();
                    return;
                } else {
                    var attachments = $scope.files;
                    var maxSize = response.MaxSize;
                    var attachSizeAllowed = true;
                    if (attachments && attachments.length) {
                        var i;
                        for (i = 0; i < attachments.length; i++) {
                            if (attachments[i].size >= maxSize) {
                                attachSizeAllowed = false;
                            }
                        }
                    }
                    if (!attachSizeAllowed) {
                        notify.error('The attachment size is too large.  Please reduce the size of the attachment and try again.');
                        vm.sendingButtonMode = 'send';
                        $scope.$applyAsync();
                        return;
                    }
                }
            });
            
            ticketService.sendReply(detail)
                .then((response) => {
                    if (!response.Success) {
                        notify.error('There was a problem submitting the ticket reply.');
                        vm.sendingButtonMode = 'send';
                        $scope.$applyAsync();
                        return;
                    } else {
                        var callback = () => {
                            $scope.$applyAsync();
                            supportService.resetCache();
                            refreshViewedTicket();
                            var ticket = vm.messages.Ticket;
                            viewTicket(ticket);
                        };

                        var attachments = $scope.files;
                        if (attachments && attachments.length) {

                            var funcs = [];
                            var i;
                            for (i = 0; i < attachments.length; i++) {
                                funcs.push(uploadAttachmentFunction(attachments[i], vm.messages.Ticket.TicketNumber, i == attachments.length - 1, callback));
                            }
                            for (i = funcs.length - 1; i >= 0; i--) {
                                funcs[i]();
                            }
                        } else
                            callback();

                        vm.sendingButtonMode = 'send';
                        $scope.$applyAsync();
                    }

                })
                .catch((err) => {
                    notify.error('There was a problem replying to the ticket.');
                    vm.sendingButtonMode = 'send';
                    $scope.$applyAsync();
                    return;
                });
        }

        function doSubmitTicket() {
            if (vm.newTicketForm.$invalid)
                return;

            if (!vm.newTicket.product) {
                notify.error('A product is required to submit a ticket.');
                return;
            }

            if (vm.needsLicense() && !vm.newTicket.license) {
                notify.error('A license with an active Maintenance and Support is required to submit a ticket.');
                return;
            }

            var details = {
                IsEmergency: false,
                FromAddress: vm.newTicket.fromEmail,
                CCAddress: vm.newTicket.ccEmail,
                Subject: vm.newTicket.subject,
                Body: vm.newTicket.message,
                IsHtml: false,
                Product: vm.newTicket.product,
                OS: vm.newTicket.os,
                License: vm.newTicket.product === 'Hosted SmarterTrack' || vm.newTicket.product === 'Active Partner'
                    ? ''
                    : vm.newTicket.license
            };

            document.querySelectorAll('button').forEach(button => {
                button.disabled = true;
            });
            $scope.accountCtrl.isLoading += 1;
            let attachments = $scope.files;
            
            if (attachments && attachments.length) {
                ticketService.getAllowedAttachmentSize()
                    .then((response) => {
                        if (!response.Success) {
                            notify.error('There was a problem submitting the ticket reply.');
                            return;
                        } else {
                            var maxSize = response.MaxSize;
                            var attachSizeAllowed = true;
                            var i;
                            for (i = 0; i < attachments.length; i++) {
                                if (attachments[i].size >= maxSize) {
                                    attachSizeAllowed = false;
                                }
                            }
                            if (!attachSizeAllowed) {
                                notify.error('The attachment size is too large.  Please reduce the size of the attachment and try again.');
                                return;
                            } else {
                                ticketService.submitTicket(details)
                                    .then((data) => {
                                        if (!data.Success) {
                                            notify.error('There was an error creating the ticket.  Please contact us for assistance.');
                                            return;
                                        } else {
                                            vm.newTicket.TicketNumber = data.TicketNumber;
                                            var callback = () => {
                                                $scope.$applyAsync();
                                                $rootScope.$broadcast('ticketModalsController:submitted', {});

                                                if (typeof refresh === 'function')
                                                    refresh(true);
                                                vm.newTicket.modalPage = 'result';

                                                document.querySelectorAll('button').forEach(button => {
                                                    button.disabled = false;
                                                });
                                                $scope.accountCtrl.isLoading -= 1;
                                            };

                                            if (attachments && attachments.length) {
                                                var funcs = [];
                                                var i;
                                                for (i = 0; i < attachments.length; i++) {
                                                    funcs.push(uploadAttachmentFunction(attachments[i], vm.newTicket.TicketNumber, i == attachments.length - 1, callback));
                                                }
                                                for (i = funcs.length - 1; i >= 0; i--) {
                                                    funcs[i]();
                                                }
                                            } else
                                                callback();
                                        }

                                    })
                                    .catch((err) => {
                                        notify.error('There was an error creating the ticket.  Please contact us for assistance.');

                                        document.querySelectorAll('button').forEach(button => {
                                            button.disabled = false;
                                        });
                                        $scope.accountCtrl.isLoading -= 1;
                                    });
                            }
                        }
                    });
            } else {
                ticketService.submitTicket(details)
                    .then((data) => {
                        if (!data.Success) {
                            notify.error('There was an error creating the ticket.  Please contact us for assistance.');
                            return;
                        } else {
                            vm.newTicket.TicketNumber = data.TicketNumber;
                            var callback = () => {
                                $scope.$applyAsync();
                                $rootScope.$broadcast('ticketModalsController:submitted', {});

                                if (typeof refresh === 'function')
                                    refresh(true);
                                vm.newTicket.modalPage = 'result';

                                document.querySelectorAll('button').forEach(button => {
                                    button.disabled = false;
                                });
                                $scope.accountCtrl.isLoading -= 1;
                            };

                            if (attachments && attachments.length) {
                                var funcs = [];
                                var i;
                                for (i = 0; i < attachments.length; i++) {
                                    funcs.push(uploadAttachmentFunction(attachments[i], vm.newTicket.TicketNumber, i == attachments.length - 1, callback));
                                }
                                for (i = funcs.length - 1; i >= 0; i--) {
                                    funcs[i]();
                                }
                            } else
                                callback();
                        }

                    })
                    .catch((err) => {
                        notify.error('There was an error creating the ticket.  Please contact us for assistance.');

                        document.querySelectorAll('button').forEach(button => {
                            button.disabled = false;
                        });
                        $scope.accountCtrl.isLoading -= 1;
                    });
            }
        }

        function uploadAttachmentFunction(attachment, tn, isLast, callback) {
            return () => {
                var fileDetails = {
                    FileSize: attachment.size,
                    TicketNumber: tn,
                    File: attachment
                };

                if (isLast) {
                    ticketService.sendTicketAttachment(fileDetails)
                        .then((data) => {
                            if (!data.Success) {
                                notify.error('There was an error adding an attachment to the ticket.  Please contact us for assistance.');
                                return;
                            } else {
                                $scope.files = [];
                                if (typeof callback === 'function') callback();
                            }
                        });

                } else {
                    ticketService.sendTicketAttachment(fileDetails)
                        .then((data) => {
                            if (!data.Success) {
                                notify.error('There was an error adding an attachment to the ticket.  Please contact us for assistance.');
                                return;
                            }
                        });
                }
            }
        }

        function getEmailAddresses() {
            ticketService.getAccountSettings()
                .then(function (data) {
                    vm.custAddress = data.Details.EmailAddress;
                    vm.userAddress = authenticationService.getLoggedInEmail();
                });
        }

        function hasLicenses() {
            return vm.Licenses && (
                (vm.Licenses.SmarterMail && vm.Licenses.SmarterMail.length) ||
                (vm.Licenses.SmarterStats && vm.Licenses.SmarterStats.length) ||
                (vm.Licenses.SmarterTrack && vm.Licenses.SmarterTrack.length));
        }

        function hasActiveTrial() {
            return vm.Trials && (
                (vm.Trials.SmarterMail && vm.Trials.SmarterMail.length) ||
                (vm.Trials.SmarterStats && vm.Trials.SmarterStats.length) ||
                (vm.Trials.SmarterTrack && vm.Trials.SmarterTrack.length));
        }

        function getLicenses() {
            $scope.accountCtrl.isLoading += 2;

            $q
                .all([
                    hostingService.getServices(),
                    licenseService.getLicensesSupport()
                ])
                .then((arr) => {
                    const hostedData = arr[0];
                    const licenseData = arr[1];

                    vm.Licenses = {
                        'SmarterMail': [],
                        'SmarterStats': [],
                        'SmarterTrack': []
                    };

                    vm.Trials = {
                        'SmarterMail': [],
                        'SmarterStats': [],
                        'SmarterTrack': []
                    };

                    const now = new Date();

                    if (hostedData.Services) {
                        for (let i = 0; i < hostedData.Services.length; i++) {
                            if (hostedData.Services[i].Status === 'active' ||
                                hostedData.Services[i].Status === 'trial') {
                                vm.hasHosted = true;
                                break;
                            }
                        }
                    }
                    for (let idx = 0; idx < licenseData.Licenses.length; idx++) {
                        const expires = new Date(licenseData.Licenses[idx].UpgradeProtectionExpiresUtc);
                        if (now < expires) {
                            const license = licenseData.Licenses[idx];
                            license.MaskedKey = license.LicenseKey.substring(0, 6) +
                                '-*******-' +
                                license.LicenseKey.substring(35);

                            if (license.ShortProduct.indexOf('SmarterMail') > -1) {
                                vm.hasMail = true;
                                vm.Licenses.SmarterMail.push(license);
                            } else if (license.ShortProduct.indexOf('SmarterTrack') > -1) {
                                vm.hasTrack = true;
                                vm.Licenses.SmarterTrack.push(license);
                            } else if (license.ShortProduct.indexOf('SmarterStats') > -1) {
                                vm.hasStats = true;
                                vm.Licenses.SmarterStats.push(license);
                            }
                        }
                    }
                    for (let jdx = 0; jdx < licenseData.Trials.length; jdx++) {
                        const trialExpires = new Date(licenseData.Trials[jdx].TrialExpiresUtc);
                        if (now < trialExpires) {
                            const trial = licenseData.Trials[jdx];
                            trial.MaskedKey = trial.LicenseKey.substring(0, 6) +
                                '-*******-' +
                                trial.LicenseKey.substring(35);

                            if (trial.ShortProduct.indexOf('SmarterMail') > -1) {
                                vm.hasMail = true;
                                vm.Trials.SmarterMail.push(trial);
                            } else if (trial.ShortProduct.indexOf('SmarterTrack') > -1) {
                                vm.hasTrack = true;
                                vm.Trials.SmarterTrack.push(trial);
                            } else if (trial.ShortProduct.indexOf('SmarterStats') > -1) {
                                vm.hasStats = true;
                                vm.Trials.SmarterStats.push(trial);
                            }
                        }
                    }

                    $scope.accountCtrl.isLoading -= 2;

                    $scope.$applyAsync();
                })
                .catch((err) => {
                    $scope.accountCtrl.isLoading -= 2;
                });
        }

        function goToModifyLicense() {
            sessionStorage.setItem('modifyLicense_back',
                JSON.stringify({
                    url: $location.$$absUrl,
                    display: 'Technical Support'
                }));
            location.href = '/purchase/#/modify-license';
        }

        function hideMessage(ticketMessageId) {
            let msgItem;
            for (let i = 0; i < vm.messages.items.length; i++) {
                if (vm.messages.items[i].ReplyId === ticketMessageId) {
                    msgItem = vm.messages.items[i];
                    break;
                }
            }

            if (!msgItem)
                return;

            msgItem.Expanded = false;
        }

        function needsLicense() {
            if (!vm.newTicket || !vm.newTicket.product || vm.newTicket.product === ''
                || vm.newTicket.product === 'Active Partner' || vm.newTicket.product === 'Hosted SmarterTrack')
                return false;

            return true;
        }

        function loadLicenses() {
            $scope.$applyAsync();
        }

        function refreshViewedTicket() {
            if (!vm.messages || !vm.messages.Ticket)
                return;

            ticketService.refreshTicket(vm.messages.Ticket.TicketID)
                .then((result) => {
                    if (!result) return;

                    vm.messages.Ticket = result;

                    if ($scope && $scope.support) {
                        if ($scope.support.openTickets) {
                            for (let i = 0; i < $scope.support.openTickets.length; i++) {
                                if ($scope.support.openTickets[i].TicketID === vm.messages.Ticket.TicketID) {
                                    $scope.support.openTickets[i] = result;
                                    break;
                                }
                            }
                        }

                        if ($scope.support.allTickets) {
                            for (let i = 0; i < $scope.support.allTickets.length; i++) {
                                if ($scope.support.allTickets[i].TicketID === vm.messages.Ticket.TicketID) {
                                    $scope.support.allTickets[i] = result;
                                    break;
                                }
                            }
                        }
                    }
                });
        }

        function showMessage(ticketMessageId) {
            let msgItem;
            for (let i = 0; i < vm.messages.items.length; i++) {
                if (vm.messages.items[i].ReplyId === ticketMessageId) {
                    msgItem = vm.messages.items[i];
                    break;
                }
            }

            if (!msgItem)
                return;

            if (msgItem.MessageBody) {
                msgItem.Expanded = true;
                return;
            }

            $q.all([
                ticketService.getMessageBody(ticketMessageId),
                ticketService.getMessageAttachments(ticketMessageId)
            ])
                .then((arr) => {
                    const msg = arr[0];
                    const attch = arr[1];

                    msgItem.Expanded = true;
                    msgItem.MessageBody = msg.Body.replace(/\r/, '')
                        .replace(/\n/g, '<br>');
                    msgItem.Attachments = attch.Attachments;

                })
                .catch((err) => {
                    notify.error('There was a problem retrieving the ticket message.');
                    return;
                });
        }

        function showReply() {
            if (!vm.messages)
                return;

            vm.messages.page = 'replyTo';

            vm.ticketReplyForm.$setPristine();
            vm.ticketReplyForm.$setUntouched();

            vm.messages.New = {
                Subject: vm.messages.Ticket.Subject,
                fromEmail: vm.userAddress,
                Body: ''
            };

            vm.messages.cancelMessage = cancelTicketReply;
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function startTicket() {
            vm.newTicket = {
                Selections: { Product: 'support' },
                Licenses: [],
                modalPage: 'details',
                fromEmail: vm.custAddress
            };
            if (vm.userAddress !== vm.custAddress)
                vm.newTicket.ccEmail = vm.userAddress;

            vm.newTicketForm.$setPristine();
            vm.newTicketForm.$setUntouched();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('new-ticket-modal')).show();

            $timeout(() => {
                $scope.$apply();
                RecalculateAllFloatLabelControls();
            });
        }

        const newTicketModal = document.getElementById('new-ticket-modal');
        if (newTicketModal)
            newTicketModal.addEventListener('hidden.bs.modal', () => {
                if (vm.startRsaa)
                    $rootScope.$broadcast('ticketModalsController:showRsaa', { ticketnumber: vm.newTicket.TicketNumber });
            });

        function viewTicket(details) {
            vm.messages = {};
            vm.messages.Ticket = details;
            vm.messages.page = 'view';
            vm.messages.showReply = showReply;

            ticketService.getMessages(details.TicketNumber, details.TicketID)
                .then((results) => {
                    const msgs = results.Messages;
                    msgs.sort((a, b) => {
                        if (a.CreationDateUtc > b.CreationDateUtc)
                            return -1;

                        if (a.CreationDateUtc < b.CreationDateUtc)
                            return 1;

                        return 0;
                    });

                    vm.messages.Ticket.StartDateUtc = msgs[msgs.length - 1].CreationDateUtc;
                    vm.messages.Ticket.IsLocked = results.IsLocked;
                    vm.messages.items = msgs;

                    showMessage(vm.messages.items[0].ReplyId);

                    vm.ticketMessagesForm.$setPristine();
                    vm.ticketMessagesForm.$setUntouched();

                    bootstrap.Modal.getOrCreateInstance(document.getElementById('ticket-messages-modal')).show();

                    $timeout(() => RecalculateAllFloatLabelControls());
                })
                .catch((err) => notify.error('There was a problem retrieving the ticket.'));
        }
    }

})();